import {
  ActionCardModel,
  assignConditionalItems,
  calculateScores,
  enableSeparator,
  recalculateFormulaNodes,
} from '@playbooks/action-cards-utils/src'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

export default function handleActionCards(value: ActionCard) {
  const actionCardModel = new ActionCardModel(value)

  recalculateFormulaNodes(actionCardModel)
  assignConditionalItems(actionCardModel)
  enableSeparator(value)
  calculateScores(value)
}
